import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: center;

  ${props => props.orientation === 'vertical' ?
    'top: 0; bottom: 0; right: -8px; justify-content: center; flex-direction: column;'
    :
    `
      ${props.$width ? `width: ${props.$width}px;` : `left: 0px;`}
      right: ${props.$right ? props.$right : 0 }px;
      ${props.position === 'bottom' ? `bottom: ${props.offsetBottom ? props.offsetBottom : -5}px;` : `top: ${props.offsetTop ? props.offsetTop : -8}px;`}
    `
  };
`;

const DimensionsTextWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;

  ${props => props.orientation === 'vertical' ?
    'top: 0; bottom: 0;'
    :

    `${props.position === 'bottom' ? 'bottom: -18' : 'top: -15'}px; left: 0; right: 0;`};
`;

const DimensionText = styled.span`
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;

  ${props => props.orientation === 'vertical' ?
    'transform: rotate(90deg) translateY(-10px);'
    : ''};
  ;
`;

const Line = styled.span`
  display: inline-block;

  ${props => props.orientation === 'vertical' ?
    'border-right: 1px solid black; height: 100%'
    :
    'border-bottom: 1px solid black; width: 100%'}
`;

const Arrow = styled.span`
  display: inline-block;
  width: 0;
  height: 0;
  border: solid 3px transparent;
`;

const StartArrow = styled(Arrow)`
  ${props => {
    const base = props.orientation === 'vertical' ? 'top' : 'left';
    const opposite = props.orientation === 'vertical' ? 'bottom' : 'right';
    return `
      border-${base}-width: 0;
      border-${opposite}-width: 10px;
      border-${opposite}-color: black;
    `;
  }}
`;
const EndArrow = styled(Arrow)`
  ${props => {
    const base = props.orientation === 'vertical' ? 'bottom' : 'right';
    const opposite = props.orientation === 'vertical' ? 'top' : 'left';
    return `
      border-${base}-width: 0;
      border-${opposite}-width: 10px;
      border-${opposite}-color: black;
    `;
  }}
`;

class DimensionRule extends React.Component {

  static propTypes = {
    text: PropTypes.string,
    orientation: PropTypes.string,
    $right: PropTypes.number,
    $width: PropTypes.number
  }

  render = () => {
    return (
      <Container orientation={this.props.orientation} position={this.props.position} offsetTop={this.props.offsetTop} offsetBottom={this.props.offsetBottom} $right={this.props.$right}  $width={this.props.$width}>
        <DimensionsTextWrapper orientation={this.props.orientation} position={this.props.position}>
          <DimensionText orientation={this.props.orientation}>
            {this.props.text}
          </DimensionText>
        </DimensionsTextWrapper>
        <StartArrow orientation={this.props.orientation}></StartArrow>
        <Line orientation={this.props.orientation}></Line>
        <EndArrow orientation={this.props.orientation}></EndArrow>
      </Container>
    );
  }
}
export default DimensionRule;
